import './App.css';
import BootstrapMessaging from './bootstrapMessaging';

function App() {
    return (
        <div className="App">
            <BootstrapMessaging />
        </div>
    );
}

export default App;
